import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import Seo from "../../Components/SeoComponent/Seo";
import Loader from "../../Loader";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import { fetchProfile } from "../../Services/profile/profileservice";
import { registerAutoDebitMandate } from "../../Services/AutoDebitMenu/AutoDebitMenuServices";

const CreateMandateFirst = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [error, setError] = useState("");
  // form state
  const [formData, setFormData] = useState({
    consumerMobileNo: "",
    consumerEmailId: "",
    debitStartDate: "",
    debitEndDate: "",
    maxAmount: "",
    amountType: "",
    frequency: "",
    accountNumber: "",
  });

  // store gateway response
  const [gatewayResponse, setGatewayResponse] = useState(null);
  const [mandateData, setMandateData] = useState(null);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await fetchProfile();
        setProfileData(response.data || response.data?.data || []);
      } catch (error) {
        console.error("Error fetching profile data", error);
      }
    };

    fetchProfileData();
  }, []);

  // handle change
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "consumerMobileNo") {
      const numericValue = value.replace(/\D/g, "");

      if (numericValue.length > 10) return;

      let errorMsg = "";

      if (numericValue.length > 0 && numericValue.length < 10) {
        errorMsg = "Mobile number must be 10 digits";
      }

      setError((prev) => ({
        ...prev,
        consumerMobileNo: errorMsg,
      }));

      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));

      return;
    }

    if (name === "consumerEmailId") {
      let errorMsg = "";

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (value && !emailRegex.test(value)) {
        errorMsg = "Invalid email format";
      }

      setError((prev) => ({
        ...prev,
        email: errorMsg,
      }));

      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));

      return;
    }

    if (name === "maxAmount") {
      let valueNum = value;

      valueNum = valueNum.replace(/[^0-9]/g, "");

      setFormData((prev) => ({
        ...prev,
        [name]: valueNum,
      }));

      return;
    }

    if (name === "accountNumber") {
      let valueNum = value;

      valueNum = valueNum.replace(/[^0-9]/g, "");

      setFormData((prev) => ({
        ...prev,
        [name]: valueNum,
      }));

      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const waitForSDK = () =>
    new Promise((resolve) => {
      const check = () => {
        if (window.$ && window.$.pnCheckout) resolve(true);
        else setTimeout(check, 200);
      };
      check();
    });

  useEffect(() => {
    // remove duplicates
    document.querySelector("#checkout-js")?.remove();
    document.querySelector("#jq-js")?.remove();

    const jq = document.createElement("script");
    jq.id = "jq-js";
    jq.src = "https://www.paynimo.com/paynimocheckout/client/lib/jquery.min.js";
    jq.async = false;

    jq.onload = () => {
      // console.log("JQUERY LOADED:", window.$);

      const checkout = document.createElement("script");
      checkout.id = "checkout-js";
      checkout.src =
        "https://www.paynimo.com/Paynimocheckout/server/lib/checkout.js"; // ✅ REAL SDK URL
      checkout.async = false;

      checkout.onload = () => {
        // console.log("CHECKOUT SDK LOADED:", window.$?.pnCheckout);
      };

      checkout.onerror = () => {
        console.error("FAILED TO LOAD checkout.js (CHECK URL)");
      };

      document.body.appendChild(checkout);
    };

    jq.onerror = () => {
      console.error("FAILED TO LOAD jQuery — CANNOT LOAD SDK");
    };

    document.body.appendChild(jq);
  }, []);

  // Worldline / Paynimo JS response handler
  const handleGatewayResponse = (res) => {
    setIsLoading(false);
    setGatewayResponse(res);
    // console.log("Gateway Response:", res);

    if (
      res &&
      res.paymentMethod &&
      res.paymentMethod.paymentTransaction &&
      res.paymentMethod.paymentTransaction.statusCode === "0300"
    ) {
      showSuccessToast(" Mandate created successfully!");
    } else if (
      res &&
      res.paymentMethod &&
      res.paymentMethod.paymentTransaction &&
      res.paymentMethod.paymentTransaction.statusCode === "0398"
    ) {
      showSuccessToast(" Mandate initiation in progress!");
    } else {
      showErrorToast(" Mandate creation failed!");
    }
  };

  // helper: convert yyyy-mm-dd -> dd-mm-yyyy for gateway
  const toGatewayDate = (v) => {
    if (!v) return "";
    const [y, m, d] = v.split("-");
    return `${d}-${m}-${y}`;
  };

  const isFormValid =
    formData.consumerMobileNo.length === 10 &&
    formData.consumerEmailId &&
    formData.debitStartDate &&
    formData.debitEndDate &&
    formData.maxAmount &&
    formData.amountType &&
    formData.frequency &&
    formData.accountNumber &&
    !error.consumerMobileNo &&
    !error.consumerEmailId;

  const buildReqJsonFromMandate = (mandate = {}, formData = {}) => {
    const amount = mandate.totalamount;
    const maxAmount = mandate.maxAmount;
    const amountType = mandate.amountType;
    const frequency = mandate.frequency;

    return {
      features: {
        enableAbortResponse: true,
        enableExpressPay: true,
        enableMerTxnDetails: true,
        siDetailsAtMerchantEnd: true,
        enableSI: true,
      },

      consumerData: {
        deviceId: "WEBSH2",
        token: mandate.token,
        merchantId: mandate.merchantId,
        txnId: mandate.txnId,
        consumerId: mandate.consumerId,

        returnUrl:
          "https://pgproxyuat.in.worldline-solutions.com/linuxsimulator/MerchantResponsePage.jsp",
        responseHandler: handleGatewayResponse,
        paymentMode: "netBanking",
        merchantLogoUrl:
          "https://www.paynimo.com/CompanyDocs/company-logo-vertical.png",
        currency: "INR",
        items: [
          {
            itemId: "first",
            amount: amount.toString(),
            comAmt: "0",
          },
        ],

        consumerMobileNo: mandate.consumerMobileNo || formData.consumerMobileNo,

        consumerEmailId: mandate.consumerEmailId || formData.consumerEmailId,

        // accountNo:
        //   mandate.accountNo || formData.accountNo,

        debitStartDate: toGatewayDate(mandate.debitStartDate),
        debitEndDate: toGatewayDate(mandate.debitEndDate),

        amount: amount.toString(), // ✔ MUST MATCH
        maxAmount: maxAmount.toString(), // ✔ MUST MATCH
        amountType: amountType, // ✔ correct field
        frequency: frequency, // ✔ correct field
      },
    };
  };

  // submit handler -> validate + call backend API, then checkout.js
  const handleSubmit = async (e) => {
    e.preventDefault();

    // basic validation – adapt as needed
    if (
      !formData.consumerMobileNo ||
      !formData.consumerEmailId ||
      !formData.debitStartDate ||
      !formData.debitEndDate ||
      !formData.maxAmount ||
      !formData.amountType ||
      !formData.frequency ||
      !formData.accountNumber
    ) {
      showErrorToast(" Please fill all required fields before submitting!");
      return;
    }

    try {
      setIsLoading(true);

      // payload expected by your registerAutoDebitMandate API
      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        method: "register",
        callback_url: "https://javabackend.idspay.in/api/v1/weMandate-callback",
        account_number: formData.accountNumber,

        total_amount: Number(formData.maxAmount),
        consumer_mobile_no: formData.consumerMobileNo,
        consumer_email_id: formData.consumerEmailId,
        debit_start_date: formData.debitStartDate,
        debit_end_date: formData.debitEndDate,
        debit_frequency: formData.frequency,
        tenure: 10,
        amount_type: formData.amountType,
      };

      // call backend to register mandate / generate token
      const apiRes = await registerAutoDebitMandate(payload);

      // adjust according to your actual API response structure
      const mandate = apiRes?.data?.data || apiRes?.data || apiRes || {};
      console.log("Mandate Registration Response:", mandate);
      setMandateData(mandate);

      const reqJson = buildReqJsonFromMandate(mandate);

      if (window.$ && window.$.pnCheckout) {
        window.$.pnCheckout(reqJson);
      } else {
        console.error("SDK NOT LOADED", window.$);
        showErrorToast("Checkout SDK is not loaded.");
      }
    } catch (error) {
      console.error("Error registering Auto Debit Mandate:", error);
      showErrorToast(" Mandate registration failed.");
      setIsLoading(false);
    }
  };

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading="Create Mandate" />

      <div className="bg-gray-100 flex items-center justify-center p-1">
        <form
          onSubmit={handleSubmit}
          className="bg-white shadow-lg rounded-2xl p-2 w-full max-w-6xl"
        >
          {/* Title */}
          <h2 className="text-2xl font-semibold text-center mb-2 text-blue-700">
            Create Mandate
          </h2>

          {/* Consumer Details */}
          <div className="border rounded-lg p-2 mb-2">
            <h3 className="text-lg font-medium mb-3 text-gray-700">
              Consumer Details
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1 text-gray-600">
                  Consumer Mobile No
                  <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="consumerMobileNo"
                  value={formData.consumerMobileNo}
                  onChange={handleChange}
                  placeholder="Enter Consumer Mobile No"
                  className="w-full border border-gray-300 rounded-md px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                />
                {error.consumerMobileNo && (
                  <p className="text-red-500 text-sm mt-1">
                    {error.consumerMobileNo}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-gray-600">
                  Consumer Email ID
                  <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="consumerEmailId"
                  value={formData.consumerEmailId}
                  onChange={handleChange}
                  placeholder="Enter Consumer Email ID"
                  className="w-full border border-gray-300 rounded-md px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                />
                {error.email && (
                  <p className="text-red-500 text-sm mt-1">{error.email}</p>
                )}
              </div>
            </div>
          </div>

          {/* Emandate Instruction */}
          <div className="border rounded-lg p-2 mb-3">
            <h3 className="text-lg font-medium mb-3 text-gray-700">
              Emandate Instruction
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
              <div>
                <label className="block text-sm font-medium mb-1 text-gray-600">
                  Debit Start Date
                  <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  name="debitStartDate"
                  value={formData.debitStartDate}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-gray-600">
                  Debit End Date
                  <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  name="debitEndDate"
                  value={formData.debitEndDate}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-gray-600">
                  Maximum Amount
                  <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  name="maxAmount"
                  value={formData.maxAmount}
                  onChange={handleChange}
                  placeholder="Enter Maximum Amount"
                  className="w-full border border-gray-300 rounded-md px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className="mt-2">
                <label className="block text-sm font-medium mb-1 text-gray-600">
                  Amount Type
                  <span className="text-red-500">*</span>
                </label>
                <select
                  name="amountType"
                  value={formData.amountType}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="" disabled>
                    Select Amount Type
                  </option>
                  <option value="M">Variable Amount (M)</option>
                  <option value="F">Fixed Amount (F)</option>
                </select>
              </div>

              {/* Frequency */}
              <div className="mt-2">
                <label className="block text-sm font-medium mb-1 text-gray-600">
                  Debit Frequency
                  <span className="text-red-500">*</span>
                </label>
                <select
                  name="frequency"
                  value={formData.frequency}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="" disabled>
                    Select Debit Frequency
                  </option>
                  <option value="DAIL">Daily</option>
                  <option value="WEEK">Weekly</option>
                  <option value="MNTH">Monthly</option>
                  <option value="QURT">Quarterly</option>
                  <option value="MIAN">Semi Annually</option>
                  <option value="YEAR">Yearly</option>
                  <option value="BIMN">Bi-Monthly</option>
                  <option value="ADHO">As & When Presented</option>
                </select>
              </div>

              {/* Account Number */}
              <div className="mt-2">
                <label className="block text-sm font-medium mb-1 text-gray-600">
                  Account Number
                  <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="accountNumber"
                  value={formData.accountNumber}
                  onChange={handleChange}
                  placeholder="Enter Account Number"
                  className="w-full border border-gray-300 rounded-md px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex justify-center">
            <button
              type="submit"
              disabled={!isFormValid || isLoading}
              className={`px-8 py-2 rounded-md transition text-white
              ${
                !isFormValid || isLoading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              {isLoading ? "Processing..." : "Create Mandate"}
            </button>
          </div>
        </form>
      </div>

      {/* Debug: show raw gateway response if needed */}
      {gatewayResponse && (
        <pre className="mt-4 text-xs bg-gray-900 text-green-200 p-3 rounded max-w-6xl mx-auto overflow-auto">
          {JSON.stringify(gatewayResponse, null, 2)}
        </pre>
      )}

      {/* Optional: debug mandate payload from backend */}
      {mandateData && (
        <pre className="mt-4 text-xs bg-gray-900 text-blue-200 p-3 rounded max-w-6xl mx-auto overflow-auto">
          {JSON.stringify(mandateData, null, 2)}
        </pre>
      )}
    </>
  );
};

export default CreateMandateFirst;
